<template>
  <div v-if="linkServiceType == 3 || linkServiceType == 12 || linkServiceType == 16">
    <div class="order-item-title">二维码入口</div>
    <div class="link-service-container">
      <!-- 3：自定义服务 -->
      <div v-if="linkServiceType == 3" class="linkService">
        <img :src="linkServiceInfo.picUrl">
        <div class="title">
          <span class="title">{{linkServiceInfo.serviceName}}</span>
        </div>
      </div>
      <!-- 9：美食街 -->
      <!-- 10：入驻 -->
      <!-- 11：优选服务 -->
      <!-- 12：会议室 -->
      <div v-if="linkServiceType == 12" class="linkService">
        <img :src="linkServiceInfo.roomPic">
        <div class="title">
          <span class="title">{{linkServiceInfo.roomName}}</span>
          <span class="price">{{linkServiceInfo.minFee / 100}}元 / 起</span>
        </div>
        <div class="other">容量：{{linkServiceInfo.capacityNum}}人</div>
        <div class="other">其他设施：{{linkServiceInfo.roomTag}}</div>
      </div>
      <!-- 13：活动 -->
      <!-- 14：福利 -->
      <!-- 16：自定义设施出租 -->
      <div v-if="linkServiceType == 16" class="linkService">
        <img :src="linkServiceInfo.banner">
        <div class="title">
          <span class="title">{{linkServiceInfo.title}}</span>
        </div>
      </div>
      <!-- 18：物业报修 -->
    </div>

  </div>
</template>

<script>
export default {
  props: {
    linkServiceInfo:{
      type: Object,
      default() {
        return{};
      },
    },
    linkServiceType:{
      type: Number
    }
  },
};
</script>
<style lang="scss" scoped>

.link-service-container{
  padding: 0 .32rem;
  width: 30%;
  box-sizing: border-box;
  background-color: #fff;
  // border-top: 1px solid rgb(245, 245, 245);

  .linkService{
    margin-bottom: 20px;

    img{
      width: 100%;
    }
    & > .title{
      font-size: 16px;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      margin-top: 5px;

      .price{
        color: #f00;
        text-align: right;
        flex-shrink: 0;
        margin-left: 20px;
      }
    }
    .other{
      line-height: 1;
      font-size: 12px;
      color: #666;
      margin-bottom: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/navigator/personal/components/details/LinkServiceContainer.vue